var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Selling_Icon",
    "data-name": "Selling Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 47.882,
    viewBox: "0 0 50 47.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 50,
    height: 47.882,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M49.681,138.187,25,143.321.318,138.187A.4.4,0,0,1,0,137.8V119.7a.4.4,0,0,1,.481-.392L25,124.407l24.518-5.1A.4.4,0,0,1,50,119.7v18.1a.4.4,0,0,1-.319.392",
    transform: "translate(0 -95.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M100.918,52.739a6.663,6.663,0,1,1-8.622,3.8,6.663,6.663,0,0,1,8.622-3.8",
    transform: "translate(-73.474 -41.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M55.284,48.223a2.915,2.915,0,1,1-3.772,1.663,2.915,2.915,0,0,1,3.772-1.663",
    transform: "translate(-41.051 -38.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M32.924,26.882l1.239-.258L12.334,18.152,18.421,2.47,53.514,16.091l-2.748,7.08,2.334-.486,2.858-7.362a.4.4,0,0,0-.228-.518L17.653.027a.4.4,0,0,0-.518.228L9.891,18.92a.4.4,0,0,0,.228.518l15,5.82Z",
    transform: "translate(-7.891 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M171.72,99.669a2.915,2.915,0,0,0,.383.116l2.418-.5a2.9,2.9,0,0,0,1.03-1.443,2.915,2.915,0,1,0-3.831,1.83",
    transform: "translate(-135.887 -75.228)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelling);
export default __webpack_public_path__ + "static/media/selling.83f6f516d8f02b19d08f80032e4a1696.svg";
export { ForwardRef as ReactComponent };